module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-content-header ci-header-container"
  }, [_c('section', {
    staticClass: "header-main-content"
  }, [_c('ci-icon-badge', {
    attrs: {
      "status": _vm.status
    }
  }), _vm._v(" "), _c('strong', [_vm._v("\n      " + _vm._s(_vm.itemName) + " #" + _vm._s(_vm.itemId) + "\n    ")]), _vm._v("\n\n    triggered\n\n    "), _c('timeago-tooltip', {
    attrs: {
      "time": _vm.time
    }
  }), _vm._v("\n\n    by\n\n    "), (_vm.user) ? [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "js-user-link commit-committer-link",
    attrs: {
      "href": _vm.user.path,
      "title": _vm.user.email
    }
  }, [_c('user-avatar-image', {
    attrs: {
      "img-src": _vm.user.avatar_url,
      "img-alt": _vm.userAvatarAltText,
      "tooltip-text": _vm.user.name,
      "img-size": 24
    }
  }), _vm._v("\n\n        " + _vm._s(_vm.user.name) + "\n      ")], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.actions.length) ? _c('section', {
    staticClass: "header-action-buttons"
  }, [_vm._l((_vm.actions), function(action) {
    return [(action.type === 'link') ? _c('a', {
      class: action.cssClass,
      attrs: {
        "href": action.path
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n      ")]) : (action.type === 'ujs-link') ? _c('a', {
      class: action.cssClass,
      attrs: {
        "href": action.path,
        "data-method": "post",
        "rel": "nofollow"
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n      ")]) : (action.type === 'button') ? _c('button', {
      class: action.cssClass,
      attrs: {
        "disabled": action.isLoading,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.onClickAction(action)
        }
      }
    }, [_vm._v("\n        " + _vm._s(action.label) + "\n        "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (action.isLoading),
        expression: "action.isLoading"
      }],
      staticClass: "fa fa-spin fa-spinner",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()]
  }), _vm._v(" "), (_vm.hasSidebarButton) ? _c('button', {
    staticClass: "btn btn-default visible-xs-block visible-sm-block sidebar-toggle-btn js-sidebar-build-toggle js-sidebar-build-toggle-header",
    attrs: {
      "type": "button",
      "aria-label": "Toggle Sidebar",
      "id": "toggleSidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left",
    attrs: {
      "aria-hidden": "true",
      "aria-labelledby": "toggleSidebar"
    }
  })]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a799207"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/header_ci_component.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7a799207"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/header_ci_component.vue
// module chunks = common_vue